var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _clipPath, _path, _path2, _path3, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavenex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 164 31.7",
    viewBox: "0 0 164 31.7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 34)",
    gradientUnits: "userSpaceOnUse",
    x1: 7.442,
    x2: 29.7888,
    y1: 15.2383,
    y2: 28.1422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#182f59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3ba7c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bce2e8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ac3e1"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 34)",
    gradientUnits: "userSpaceOnUse",
    x1: 14.49,
    x2: 31.5317,
    xlinkHref: "#b",
    y1: 28.14,
    y2: 18.299
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 34)",
    gradientUnits: "userSpaceOnUse",
    x1: 14.4934,
    x2: 25.9683,
    xlinkHref: "#b",
    y1: 28.1459,
    y2: 21.5131
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.2 5.9h-7.4-15.3-14.5l14.9 25.8 7.2-12.6 3.8 6.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.8 5.9-14.9 25.8-14.9-25.8z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.2 5.9-11.3 19.6-11.4-19.6z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8 5.9h-15.3l7.6 13.2z",
    fill: "url(#d)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.6,
    cy: 5.9,
    opacity: 0.5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6 15.5c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-13.6c-3.6 0-6.6 3-6.6 6.6s2.9 6.6 6.6 6.6 6.6-2.9 6.6-6.6c0-3.6-3-6.6-6.6-6.6z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6 21.4c-5.9 0-10.7-4.8-10.7-10.7s4.8-10.7 10.7-10.7 10.7 4.8 10.7 10.7-4.8 10.7-10.7 10.7zm0-21.2c-5.8 0-10.6 4.7-10.6 10.5s4.7 10.5 10.5 10.5 10.6-4.7 10.6-10.5-4.7-10.5-10.5-10.5z",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#3ba7c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.7 15.3v9.1h-2v-8.8c0-2-.8-2.6-2.1-2.6-1.5 0-2.5 1-3.4 2.4v9.1h-2v-12.8h1.7l.1 1.9c.9-1.4 2.4-2.2 4-2.2 2.3 0 3.7 1.5 3.7 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.2 18.7h-8.2c.2 3.1 1.6 4.3 3.6 4.3 1.2 0 2.4-.4 3.3-1.1l.9 1.2c-1.2 1-2.8 1.6-4.4 1.6-3.5 0-5.6-2.5-5.6-6.5s2-6.8 5.2-6.8c3.4 0 5.2 2.4 5.2 6.2.1.4.1.9 0 1.1zm-2-1.7c0-2.6-1-4-3.1-4-1.8 0-2.9 1.2-3.1 4.2h6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.6 24.4-3.2-5.5-3.3 5.5h-2.3l4.4-6.7-3.9-6h2.4l2.8 4.8 2.8-4.8h2.3l-3.9 5.9 4.5 6.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#182f59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.9 24.4-2.3-10.9-2.4 10.9h-2.7l-3-12.7h2.1l2.3 11.3 2.6-11.3h2.3l2.4 11.3 2.4-11.3h1.9l-2.9 12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.8 23.2-.5 1.4c-1.1 0-2.1-.8-2.4-1.9-.8 1.3-2.3 2-3.8 2-2 .2-3.8-1.3-4-3.3 0-.2 0-.3 0-.5 0-2.7 2-4.2 5.5-4.2h2.1v-1c0-1.9-.9-2.6-2.7-2.6-1.2 0-2.3.3-3.4.7l-.5-1.5c1.4-.6 2.8-.8 4.3-.9 3 0 4.4 1.5 4.4 4.2v5.9c0 1.1.4 1.5 1 1.7zm-3-2.2v-3h-1.8c-2.4 0-3.6.9-3.6 2.7-.2 1.2.6 2.2 1.8 2.4h.5c1.3 0 2.5-.8 3.1-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.3 24.4-4.4-12.7h2.2l3.5 10.9 3.4-10.9h2.2l-4.4 12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.8 18.7h-8.2c.2 3.1 1.6 4.3 3.6 4.3 1.2 0 2.4-.4 3.3-1.1l.9 1.2c-1.2 1-2.8 1.6-4.3 1.6-3.5 0-5.6-2.5-5.6-6.5s2-6.8 5.2-6.8c3.4 0 5.2 2.4 5.2 6.2-.1.4-.1.9-.1 1.1zm-2-1.7c0-2.6-1-4-3.1-4-1.8 0-3 1.2-3.1 4.2h6.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavenex);
export default __webpack_public_path__ + "static/media/wavenex.007d578b818ec86443c38e808cdbc0a1.svg";
export { ForwardRef as ReactComponent };